import type { AppRouteData } from '@/routes/app-route.config';
import { APP_ROUTES_CONFIG } from '@/routes/app-route.config';
import { APP_URLS } from '@/routes/app.paths';

export type NavItem = AppRouteData & { path: string };

export const NAV_ITEMS: NavItem[] = [
  { ...APP_ROUTES_CONFIG.activity, path: APP_URLS.activity },
  { ...APP_ROUTES_CONFIG.opportunities, path: APP_URLS.opportunity },
  { ...APP_ROUTES_CONFIG.archive, path: APP_URLS.archive },
  { ...APP_ROUTES_CONFIG.users, path: APP_URLS.users },
  { ...APP_ROUTES_CONFIG.roles, path: APP_URLS.roles },
];
